var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details clearfix" }, [
    _c("div", { staticClass: "detail-left", attrs: { "data-test": "title" } }, [
      _c("h4", [_vm._v(_vm._s(_vm.title))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "detail-right" },
      [
        _vm._t("default", function () {
          return [
            _c(
              "job-preview-content",
              _vm._g(
                {
                  attrs: {
                    "comment-highlights": _vm.commentHighlights,
                    "text-count-mode": _vm.textCountMode,
                    "highlight-mode": _vm.highlightMode,
                    "text-counts": _vm.textCounts,
                    "target-id": _vm.targetId,
                    value: _vm.value,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "supplement",
                        fn: function () {
                          return [_vm._t("supplement")]
                        },
                        proxy: true,
                      },
                      {
                        key: "sub",
                        fn: function () {
                          return [_vm._t("sub")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                _vm.$listeners
              )
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }